import { useDispatch, useSelector } from "react-redux"
import { producttypeActions } from "../../../../../store/producttype-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, producttypes } = props
    let selectedpagination = useSelector(state => state.producttype.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(producttypeActions.setFilteredItems(producttypes))
        dispatch(producttypeActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;